import { z } from 'zod';
import { GenericLegalTransactionRelationshipSchema } from '../../GenericLegalTransactionRelationshipSchema';
import {
  ILegalTransactionRelationship,
  initLegalTransactionRelationshipSkeleton,
} from '../../ILegalTransactionRelationship';
import { LegalTransactionRelationshipTypeEnum } from '../../LegalTransactionRelationshipTypeEnum';
import {
  IMemberParticipant,
  ParticipantMemberSchema,
} from '../../Members/IMemberParticipant';
import {
  GeneralRelationshipDataSchema,
  getEmptyGeneralRelationshipData,
} from './ILegalTransactionRelationshipGeneralData';

export const GeneralRelationshipSchema =
  GenericLegalTransactionRelationshipSchema(
    z.literal(LegalTransactionRelationshipTypeEnum.General),
    z.literal(2).optional(),
    GeneralRelationshipDataSchema,
    ParticipantMemberSchema
  );

export type IGeneralRelationship = Omit<
  z.infer<typeof GeneralRelationshipSchema>,
  'Members'
> & {
  Members: IMemberParticipant[];
};

export function getEmptyGeneralRelationship(): IGeneralRelationship {
  return {
    ...initLegalTransactionRelationshipSkeleton(),
    Version: 2,
    idRelationshipType: LegalTransactionRelationshipTypeEnum.General,
    data: getEmptyGeneralRelationshipData(),
    Members: [],
  };
}

export function isGeneralRelationship(
  relationship: ILegalTransactionRelationship | undefined
): relationship is IGeneralRelationship {
  return (
    !!relationship &&
    relationship.idRelationshipType ===
      LegalTransactionRelationshipTypeEnum.General
  );
}
